import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/lib/images";
import { Megaphone, Building2, ArrowRight, List, Map } from "lucide-react";

export default function DeclareChoice() {
  const { t } = useLang();
  return (
    <div className="bg-background min-h-[70vh]">
      <div className="relative h-64 sm:h-72 overflow-hidden photo-scrim">
        <motion.img
          initial={{ opacity: 0, scale: 1.08 }} animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          src={IMAGES.heroDeclare} alt=""
          className="w-full h-full object-cover object-[center_12%] animate-ken-burns" data-testid="declare-choice-banner" />
        <div className="absolute inset-0 bg-[#191A54]/45" aria-hidden="true" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-6">
          <motion.h1
            initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15, duration: 0.6 }}
            className="font-display text-3xl md:text-4xl font-semibold">{t("dc.title")}</motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.25, duration: 0.6 }}
            className="mt-2 text-white/85 max-w-md text-sm md:text-base">{t("dc.subtitle")}</motion.p>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-6 py-12 grid gap-5" data-testid="declare-choice">
        {/* Option A — Public declaration */}
        <Link to="/annonces/nouvelle" data-testid="declare-choice-public"
          className="group rounded-2xl border border-border bg-white card-shadow p-6 hover:border-findo-red hover:bg-findo-red/[0.03] transition-colors">
          <div className="flex items-start gap-4">
            <div className="h-12 w-12 rounded-xl bg-findo-red/10 text-findo-red grid place-items-center shrink-0"><Megaphone size={22} /></div>
            <div className="min-w-0">
              <p className="font-display font-semibold text-lg text-findo-navy flex items-center gap-1.5">
                {t("dc.publicTitle")}
                <ArrowRight size={16} className="opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" />
              </p>
              <p className="text-sm text-slate-500 mt-1.5">{t("dc.publicDesc")}</p>
              <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-findo-red">{t("dc.publicCta")}</span>
            </div>
          </div>
        </Link>

        {/* Option B — Partner declaration */}
        <div className="rounded-2xl border border-border bg-white card-shadow p-6" data-testid="declare-choice-partner">
          <div className="flex items-start gap-4">
            <div className="h-12 w-12 rounded-xl bg-findo-navy/10 text-findo-navy grid place-items-center shrink-0"><Building2 size={22} /></div>
            <div className="min-w-0">
              <p className="font-display font-semibold text-lg text-findo-navy">{t("dc.partnerTitle")}</p>
              <p className="text-sm text-slate-500 mt-1.5">{t("dc.partnerDesc")}</p>
              <div className="mt-4 flex flex-wrap gap-2.5">
                <Link to="/partners" data-testid="declare-choice-partner-list"
                  className="inline-flex items-center gap-2 h-11 px-4 rounded-xl border border-findo-navy text-findo-navy font-semibold text-sm hover:bg-findo-navy/5 transition-colors">
                  <List size={16} /> {t("dc.partnerList")}
                </Link>
                <Link to="/carte" data-testid="declare-choice-partner-map"
                  className="inline-flex items-center gap-2 h-11 px-4 rounded-xl border border-findo-navy text-findo-navy font-semibold text-sm hover:bg-findo-navy/5 transition-colors">
                  <Map size={16} /> {t("dc.partnerMap")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
